import { render, staticRenderFns } from "./IdeaTemplatesList.vue?vue&type=template&id=1babb8ce"
import script from "./IdeaTemplatesList.vue?vue&type=script&lang=js"
export * from "./IdeaTemplatesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports